<template>
    <div class="view">
        <h4>{{home.title}}</h4>
        <img class="logoSgp" src="../assets/images/SGP-RVB-Noir-XL.png">
        <p class="mt-3" v-if="lastLogin">Dernière connexion le : {{lastLogin}}.</p>
        <br/>
        <h5 v-if="!isAdmin">{{home.subTitle}}</h5>
        <br/>
        <b-col cols="10" v-if="!isAdmin">
            <b-row class="mb-3">
                <b-col cols="2">
                    <b-button size="sm" variant="success">Fait dans les temps</b-button>
                </b-col>
                <b-col cols="2" v-if="isCorrespondantGpec">
                    <b-button size="sm" :class="'BROUILLON'">Brouillon à valider</b-button>
                </b-col>
                <b-col cols="2">
                    <b-button size="sm" variant="warning">Fait en retard ou modifié</b-button>
                </b-col>
                <b-col cols="1">
                    <b-button size="sm" variant="danger">Non fait</b-button>
                </b-col>
                <b-col cols="2">
                    <b-button size="sm" variant="secondary">Non demandé</b-button>
                </b-col>
                <b-col cols="3">
                    <b-button size="sm" variant="primary">Rien à déclarer pour la période</b-button>
                </b-col>
            </b-row>
            <b-card header="Tableau mensuel" class="mb-3 mt-3" v-if="isCorrespondant">
                <b-row>
                    <b-col cols="4">
                        <b-form-group id="input-group-date" label-for="input-date">
                            <template v-slot:label>
                                <label-custom
                                        label="Mois"
                                        tooltip="Indiquer le mois du reporting"
                                        :required="true">
                                </label-custom>
                            </template>
                            <vue-monthly-picker
                                    id="input-date"
                                    dateFormat="MM/YYYY"
                                    :monthLabels="monthLabels"
                                    v-model="date"
                                    @selected="search">
                            </vue-monthly-picker>
                            <div class="typo-warning" v-if="!date">
                                {{libelles.champObligatoire}}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div v-if="reportingMensuelResult">
                    <b-table striped hover fixed
                             :no-local-sorting="true"
                             :items="reportingMensuelTable" :fields="fieldsMensuel">
                        <template v-slot:cell(statutEmpreinte)>
                        </template>
                        <template v-slot:cell(statutEffectifs)>
                        </template>
                        <template v-slot:cell(statutAccidentologie)>
                        </template>
                    </b-table>
                </div>
            </b-card>
            <b-card header="Tableau Trimestriel" class="mb-3 mt-3" v-if="isCorrespondantGpec">
                <b-row>
                    <b-col cols="4">
                        <b-form-group
                                id="input-group-trimestres"
                                label-for="input-trimestres">
                            <template v-slot:label>
                                <label-custom
                                        :label=libelles.trimestreSaisie
                                        :tooltip=libelles.trimestreSaisie
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-trimestres"
                                    v-model="trimestreId"
                                    :options="trimestres"
                                    @change="search"
                            >
                            </b-form-select>
                            <div class="typo-warning" v-if="!trimestreId">
                                {{libelles.champObligatoire}}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div v-if="reportingTrimestrielResult">
                    <b-table striped hover fixed
                             :no-local-sorting="true"
                             :items="reportingTrimestrielTable" :fields="fieldsTrimestriel">
                        <template v-slot:cell(statutGpecPrevisionnel)>
                        </template>
                        <template v-slot:cell(statutGpecRealise)>
                        </template>
                    </b-table>
                </div>
            </b-card>
        </b-col>
        <b-col cols="10" v-if="isAdmin && !isOutherAdmin && nombreMarcheIndetermine>0">
          <b-card header="Alertes :">
            Nombre de marché dont le territoire est "En cours d'attribution" : {{nombreMarcheIndetermine}}
          </b-card>
        </b-col>
    </div>
</template>

<script>
  import ReportingStore from "../stores/ReportingStore";
  import ReportingSearchDto from "../dtos/ReportingSearchDto";
  import VueMonthlyPicker from "vue-monthly-picker";
  import LabelCustom from "../components/LabelCustom";
  import {mois} from "../constants/enums";
  import AlertStore from "../stores/AlertStore";
  import hasPermission from "../filters/hasPermission";
  import {momentToDate} from "../utils/dateUtil";
  import moment from 'moment';
  import {home, libelles} from '../constants/libelles';
  import {
    ROLES_ADMIN,
    ROLES_EFFECTIFS,
    ROLES_EMPREINTE,
    ROLES_GPEC,
    ROLES_SECURITE
  } from "../constants/common";
  import TrimestreStore from "../stores/TrimestreStore";
  import SessionStore from '@/stores/SessionStore';
  import {EventBus} from '@/event-bus'
  import MarcheStore from "@/stores/MarcheStore";


  export default {
    name: 'home',
    components: {
      LabelCustom,
      VueMonthlyPicker,
    },
    data() {
      return {
        home: home,
        libelles: libelles,
        date: null,
        monthLabels: mois,
        reportingMensuelResult: null,
        reportingTrimestrielResult: null,
        trimestreId: null,
        trimestres: [],
        sessionStoreState: SessionStore.state,
        marcheId: null,
        nombreMarcheIndetermine: null
      };
    },
    computed: {
      lastLogin() {
        return this.sessionStoreState.lastLogin ? moment(this.sessionStoreState.lastLogin).format("DD/MM/YYYY à HH[h]mm") : null;
      },
      isAdmin() {
        return hasPermission(ROLES_ADMIN);
      },
      isOutherAdmin() {
        return hasPermission(ROLES_EMPREINTE) || hasPermission(ROLES_EFFECTIFS) || hasPermission(ROLES_SECURITE);
      },
      isCorrespondant() {
        return (hasPermission(ROLES_EMPREINTE) || hasPermission(ROLES_EFFECTIFS) || hasPermission(ROLES_SECURITE)) && !this.isAdmin;
      },
      isCorrespondantGpec() {
        return hasPermission(ROLES_GPEC) && !this.isAdmin;
      },
      fieldsMensuel() {
        const fieldsMensuel = [
          {label: 'Marché', key: 'referenceMarche'},
        ];
        if (hasPermission(ROLES_EMPREINTE)) {
          fieldsMensuel.push({label: 'Empreinte économique', key: 'statutEmpreinte', tdClass: 'setBackground'})
        }
        if (hasPermission(ROLES_EFFECTIFS)) {
          fieldsMensuel.push({label: 'Effectifs', key: 'statutEffectifs', tdClass: 'setBackground'})
        }
        if (hasPermission(ROLES_SECURITE)) {
          fieldsMensuel.push({label: 'Accidentologie', key: 'statutAccidentologie', tdClass: 'setBackground'})
        }
        return fieldsMensuel;
      },
      fieldsTrimestriel() {
        return [
          {label: 'Marché', key: 'referenceMarche'},
          {label: 'GPEC – Besoins prév.', key: 'statutGpecPrevisionnel', tdClass: 'setBackground'},
          {label: 'GPEC – Bilan trimestriel', key: 'statutGpecRealise', tdClass: 'setBackground'}
        ];
      },
      reportingMensuelTable: function () {
        return this.reportingMensuelResult.map(reporting => {
          return {
            referenceMarche: reporting.marche,
            statutEmpreinte: reporting.statutEmpreinte,
            statutEffectifs: reporting.statutEffectifs,
            statutAccidentologie: reporting.statutAccidentologie,
          }
        });
      },
      reportingTrimestrielTable: function () {
        return this.reportingTrimestrielResult.map(reporting => {
          return {
            referenceMarche: reporting.marche,
            statutGpecPrevisionnel: reporting.statutGpecPrevisionnel,
            statutGpecRealise: reporting.statutGpecRealise,
          }
        });
      }
    },
    mounted() {
      if (!this.isAdmin) {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
          this.search();
        });
      }
      if (this.isCorrespondantGpec) {
        TrimestreStore.getAll().then((trimestres) => {
          this.trimestres = trimestres.map(function (trimestre) {
            return {text: trimestre.libelle, value: trimestre.id};
          });
        });
        TrimestreStore.getCurrentTrimestre(true).then((trimestre) => {
          this.trimestreId = trimestre.id;
          this.search();
        });
      }
      if (this.isCorrespondant) {
        ReportingStore.getCurrentMonth().then(currentMonth => {
          this.date = moment(currentMonth).startOf("month");
          this.search();
        })
      }
      if (this.isAdmin) {
        this.getMarcheTerritoireIndetermine();
      }
    },
    methods: {
      search() {
        const reporting = this.createReportingRecherche();
        if (this.date && this.isCorrespondant) {
          ReportingStore.search(reporting, true).then(
              result => {
                this.reportingMensuelResult = result.data;
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
        if (this.trimestreId && this.isCorrespondantGpec) {
          ReportingStore.search(reporting, false).then(
              result => {
                this.reportingTrimestrielResult = result.data;
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
      },
      createReportingRecherche() {
        const reporting = new ReportingSearchDto();
        reporting.marcheId = this.marcheId;
        reporting.date = this.date ? momentToDate(this.date) : null;
        reporting.trimestreId = this.trimestreId;
        return reporting;
      },
      setBackground(item) {
        return (item === "DISPENSE_FORMULAIRE" ? "OK" : item);
      },
      getMarcheTerritoireIndetermine() {
        MarcheStore.countMarcheTerritoireIndetermine().then(result => {
              this.nombreMarcheIndetermine = result;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
    }
  }
</script>

<style lang="scss" scoped>
  .logoSgp {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 20em
  }
</style>